import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { rethrowAsSapError } from 'src/app/lego-utils';
import { map, Observable } from 'rxjs';
import { IBomItemMaterial } from 'src/app/state/bom-item-material.model';
import { IBomItemCreate } from 'src/app/state/bom-item/bom-item-create.model';
import { IBomItemDelete } from 'src/app/state/bom-item/bom-item-delete.model';
import { IBomItemUpdate } from 'src/app/state/bom-item/bom-item-update.model';

@Injectable({
  providedIn: 'root',
})
export class BomItemUpdateService {
  public constructor(private readonly httpClient: HttpClient) {}

  public getBomItems(designId: string): Observable<IBomItemMaterial[]> {
    return this.httpClient
      .get<IBomItemMaterial[]>(`api/bom-item/${designId}`)
      .pipe(rethrowAsSapError());
  }

  public getBomItem(designId: string, id: string): Observable<IBomItemMaterial> {
    return this.httpClient
      .get<IBomItemMaterial>(`api/bom-item/${designId}/${id}`)
      .pipe(rethrowAsSapError());
  }

  public deleteBomItem(model: IBomItemDelete, designId: string): Observable<void> {
    return this.httpClient.patch<unknown>(`api/bom-item/delete/${designId}`, model).pipe(
      map(() => undefined) // map response to void
    );
  }

  public updateBomItem(model: IBomItemUpdate, designId: string) {
    return this.httpClient.patch(`api/bom-item/${designId}`, model);
  }

  public createBomItem(model: IBomItemCreate, designId: string): Observable<IBomItemMaterial> {
    return this.httpClient
      .post<IBomItemMaterial>(`api/bom-item/${designId}`, model)
      .pipe(rethrowAsSapError());
  }
}
